import React, { Component } from 'react';
import Imgix from 'react-imgix';

import { cdnUrl, useImgix } from 'common/helpers/content';

import logger from 'itrvl-logger';
const log = logger(__filename);
log.trace(__filename);

// Thin wrapper around Imgix so we have a single
// place to change image handling should we
// decide to switch back to cloud front or another
// image provider with different API
export default class Image extends Component {
  render() {
    const { src = '', sizes = '100vw', imgixParams = { fit: 'crop', crop: 'faces' }, alt, loading, ...rest } = this.props;
    if (useImgix && src && typeof src == 'string' && src.includes('imgix.net')) {
      const htmlAttributes = {
        alt,
        loading,
      };
      // log.info('htmlAttributes for this image: ', htmlAttributes);
      return <Imgix src={src} sizes={sizes} imgixParams={imgixParams} htmlAttributes={htmlAttributes} {...rest} />;
    }
    if (src !== '' && typeof src == 'string') {
      let srcCdn = src;
      try {
        if (/^https.*cdn-static.*itrvl.*com/.test(src)) {
          // Leave as is, imgix only mirrors cdn-media
        } else if (/^https.*itrvl.*com/.test(src)) {
          srcCdn = cdnUrl(src);
        }
      } catch {
        // Things like '/static/media/...'.
      }
      return <img src={srcCdn} loading={loading} alt={alt} {...rest} />;
    }
    log.warn('image with invalid source:', src);
    return <img loading={loading} alt={alt} {...rest} />;
  }
}
